const realisations = [
  { img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/a5625dc0-2ba6-4155-b7e3-cdb9a039fe35_2.jpeg?v=91deae9f5ac8ffff318b81a5126c4be6' },
  { img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/593e8b57-b159-4d05-a67d-9298764b44e5_3.jpeg?v=c71247a9903cf777bc0d2234b3177d77' },
  { img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/355a4eb5-5834-4930-adfb-5509fc9f32a2_4.jpeg?v=5a388cf5b104b50f25e8baf593eae5ca' },
  { img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/1d177d38-508f-45c4-a751-8e6f71f61c83_5.jpeg?v=a054cf4237e34fcd39fc9faf1aaffe1a' },
  { img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/e826e434-fd1f-4353-ad94-05a3d03170e4_6.jpeg?v=ac7c16e9f75eb48f05c65a1e4b696611' },
  { img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/39379d20-ea39-430a-ba50-e52ad4a82907_7.jpeg?v=f00a09fddfbd97360cdd2daae1039078' },
  { img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/94d2c83f-488c-42c2-a2e3-93a19c29acfe_8.jpeg?v=80acff62a883b7b64cc7fc6f4a04b9a3' },
  { img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/d2465bfd-2d64-468b-8e5e-d9ab9375f15a_9.jpeg?v=aa4e1af96f046897cd318fd25be3241c' },
  { img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/3776029c-10ac-4c0b-ad79-d41a0c78b21d_10.jpeg?v=4d68a8ebf498e29340b3904e2378c80b' },
  { img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/8ec639a8-4bf5-4cf2-9b30-6e223370c317_WhatsApp-Image-2026-03-21-at-17.20.51.jpeg?v=65673d4544bfe3409111a1d1ec47724f' },
];

const RealisationsSection = () => (
  <section id="realisations" className="w-full py-20 bg-white">
    <div className="max-w-7xl mx-auto px-6">

      {/* Header */}
      <div className="text-center mb-12">
        <div className="flex items-center justify-center gap-3 mb-3">
          <div className="h-px w-12 bg-[#1a8abf]" />
          <span className="text-[#1a8abf] text-xs font-bold uppercase tracking-widest">Portfolio</span>
          <div className="h-px w-12 bg-[#1a8abf]" />
        </div>
        <h2 className="text-3xl lg:text-4xl font-black leading-tight mb-3" style={{ color: '#002060' }}>
          Nos Réalisations
        </h2>
        <p className="text-[#4a6272] text-base max-w-lg mx-auto">
          Découvrez quelques-uns de nos chantiers réalisés en région Sud — des installations soignées, du particulier au professionnel.
        </p>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {realisations.map((r, i) => (
          <div
            key={i}
            className="group relative rounded-2xl overflow-hidden border border-[#e0eef8]"
            style={{ height: 280 }}
          >
            {/* Fond flouté de la même image */}
            <img
              src={r.img}
              alt=""
              aria-hidden="true"
              className="absolute inset-0 w-full h-full object-cover scale-110 blur-lg opacity-70"
            />
            {/* Image principale complète */}
            <img
              src={r.img}
              alt={`Réalisation ${i + 1}`}
              className="relative z-10 w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        ))}
      </div>

    </div>
  </section>
);

export default RealisationsSection;
